interface StatsCardProps {
  label: string;
  value: number;
  description: string;
  /** Short note in a chip beside the label, e.g. the period's forecast; null hides it. */
  badge?: string | null;
  /** Hover text explaining the chip. */
  badgeTitle?: string;
  loading?: boolean;
}

export default function StatsCard({
  label,
  value,
  description,
  badge,
  badgeTitle,
  loading,
}: StatsCardProps) {
  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm p-5">
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm font-medium text-gray-500">{label}</p>
        {badge && !loading && (
          <span
            className="inline-flex items-center whitespace-nowrap rounded-full bg-[#CDDCDF] px-2 py-0.5 text-xs font-semibold text-[#00345E] tabular-nums"
            title={badgeTitle}
          >
            {badge}
          </span>
        )}
      </div>
      {loading ? (
        <div className="mt-3 h-8 w-20 rounded bg-gray-100 animate-pulse" />
      ) : (
        <p className="mt-2 text-3xl font-semibold text-[#151818] tabular-nums">
          {value.toLocaleString("en-AU")}
        </p>
      )}
      <p className="mt-1 text-xs text-gray-400">{description}</p>
    </div>
  );
}
